import React from 'react';
import { Box } from '@material-ui/core';
import { Color } from '../../constants';

interface SectionTitleProps {
  title: string;
}

export const SectionTitle = (props: SectionTitleProps) => {
  return (
    <Box color={Color.Title} fontWeight="bold" fontSize={16} pb={0}>
      {props.title}
    </Box>
  );
};
